import * as HttpService from "./http.service";
import {
  ADD_POSITION_URL,
  GET_POSITION_BY_ID_URL,
  GET_POSITIONS_URL,
  UPDATE_POSITION_URL,
  UPDATE_POSITION_STATUS_URL,
  VALIDATE_POSITIONS_FROM_CSV_URL,
  ADD_BULK_POSITIONS_FROM_CSV_URL,
  DEACTIVATE_POSITIONS_URL,
  GET_POSITIONS_BULK_DOWNLOAD_URL,
} from "./url.service";

export const addPosition = (companyId, positionDetails) => {
  return HttpService.postWithAuth(ADD_POSITION_URL(companyId), {
    ...positionDetails,
  });
};
export const updatePosition = (positionId, positionDetails) => {
  return HttpService.putWithAuth(UPDATE_POSITION_URL(positionId), {
    ...positionDetails,
  });
};

export const updatePositionStatus = (candidateId, status) => {
  return HttpService.putWithAuth(UPDATE_POSITION_STATUS_URL(candidateId), { status });
};

export const getPositionsBulkDownload = (companyId, search = "", offset, limit, sort, filters = "") => {
  return HttpService.getWithAuth(GET_POSITIONS_BULK_DOWNLOAD_URL(companyId, search, offset, limit, sort, filters));
}

export const getPositions = (companyId, search = "", offset, limit, sort, filters = "") => {
  return HttpService.getWithAuth(GET_POSITIONS_URL(companyId, search, offset, limit, sort, filters));
}

export const getPositionById = (positionId) => {
  return HttpService.getWithAuth(GET_POSITION_BY_ID_URL(positionId));
};

export const validatePositionsFromCSV = (companyId, csvData) => {
  return HttpService.postWithAuth(VALIDATE_POSITIONS_FROM_CSV_URL(companyId), { csvData });
}

export const addPositionsFromCSV = (companyId, csvData) => {
  return HttpService.postWithAuth(ADD_BULK_POSITIONS_FROM_CSV_URL(companyId), { csvData });
}

export const deactivatePosition = (positionIds, user) => {
  return HttpService.postWithAuth(DEACTIVATE_POSITIONS_URL, { positionIds, user });
}